import { render, staticRenderFns } from "./ubruCoffeeRetrun.vue?vue&type=template&id=4d3e0a96&scoped=true"
import script from "./ubruCoffeeRetrun.vue?vue&type=script&lang=js"
export * from "./ubruCoffeeRetrun.vue?vue&type=script&lang=js"
import style0 from "./ubruCoffeeRetrun.vue?vue&type=style&index=0&id=4d3e0a96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e0a96",
  null
  
)

export default component.exports